import styles from "@/asserts/styles/formSection.module.less";
import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import { useModal } from "@/hooks/modals/useModal";
import {
  usePurchaseRequestDetail,
  purchaseRequestKeys,
} from "../hooks/usePurchaseRequest";
import { Button, Col, Form, Input, Row } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { generatePurchaseRequestPRNo } from "@/apis/requirementManagement.api";
import { useFormEditable } from "../hooks/useFormEditable";
import { useGlobalModal } from "@/hooks/context/ModalContext";
import { useTranslation } from "react-i18next";

export const OrderConfrimFormFields = () => {
  const { t } = useTranslation("purchaseRequestManagement");
  const { t: tCommon } = useTranslation("common");

  const globalModal = useGlobalModal();
  const { props } = useModal("PURCHASE_REQUEST");
  const { recordId } = props;
  const detail = usePurchaseRequestDetail(recordId);

  const { isPOFormDisabled } = useFormEditable();

  const hasPrNo = Boolean(detail?.prNo);
  const queryClient = useQueryClient();

  const generateMutation = useMutation({
    mutationFn: () => generatePurchaseRequestPRNo(detail?.id!),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: purchaseRequestKeys.detail(recordId!),
      });
    },
  });

  const onCreateClick = () => {
    globalModal.confirm({
      title: t("确认生成PR编号吗？"),
      okText: tCommon("确认"),
      okType: "primary",
      onOk: () => generateMutation.mutate(),
    });
  };

  return (
    <div className={styles.formSection}>
      <ModalSectionHeader title={t("订单确认")} />

      <div className={styles.sectionBody}>
        {!hasPrNo ? (
          <Button
            type="primary"
            disabled={isPOFormDisabled}
            onClick={onCreateClick}
          >
            {t("生成PR")}
          </Button>
        ) : (
          <Row gutter={49}>
            <Col span={8}>
              <Form.Item name="prNo" label={t("PR编号")}>
                <Input placeholder={t("请输入")} disabled />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="poNo"
                label={t("PO编号")}
                rules={[
                  {
                    required: true,
                    message: t("请输入"),
                  },
                ]}
              >
                <Input placeholder={t("请输入")} disabled={isPOFormDisabled} />
              </Form.Item>
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
};
